import {combineReducers, Reducer} from "redux";
import {createBrowserHistory, History} from "history";
import { legitReducers } from "apex-legit-service";
import { connectRouter } from "connected-react-router";
import { reducer as legacyUrlReducer } from "services/legit/legacyUrl";
import { reducer as ssoLoginReducer } from "services/legit/loginSso";
import { reducer as menuItemsReducer } from "services/legit/menuItems";
import { reducer as loginTypeReducer } from "services/legit/loginType";

export const history = createBrowserHistory();

// Create the reducer
const rootReducer = combineReducers({
    fetchLegacyUrlService: legacyUrlReducer,
    fetchMenuItemsService: menuItemsReducer,
    loginTypeService: loginTypeReducer,
    ssoLoginService: ssoLoginReducer,
    router: connectRouter(history),
    ...(legitReducers as Record<string, Reducer>),
});

export default rootReducer;
